import PreviewJobPostClient from "@Organism/Home/Business/PreviewJobPostClient";
import LoadingAnimationPage from "@Organism/LoadingAnimationPage";
import AsyncErrorBoundary from "@Organism/Utils/AsyncErrorBoundary";
import { getDetailJobPost } from "@Services/home";
import { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";

//   const { id } = route?.params;

export const loaderPreviewJobPostClient = (route) => {
  const { id } = route?.params;

  return defer({
    getDetailJobPost: getDetailJobPost(id),
  });
};
export default function PreviewJobPostClientPage() {
  const { getDetailJobPost } = useLoaderData();

  return (
    <Suspense fallback={<LoadingAnimationPage />}>
      <Await
        resolve={getDetailJobPost}
        errorElement={
          <div
            style={{
              height: "100vh",
            }}
          >
            <AsyncErrorBoundary />
          </div>
        }
      >
        {(getDetailJobPost) => (
          <PreviewJobPostClient getDetailJobPost={getDetailJobPost} />
        )}
      </Await>
    </Suspense>
  );
  // return <PreviewJobPostClient />;
}
